import React, { useEffect } from 'react';
import AppContentView from '@tenant/core/AppContentView';
import { useAuthUser } from '../../utility/AuthHooks';
import {
  useLayoutActionsContext,
  useLayoutContext,
} from '../../utility/AppContextProvider/LayoutContextProvider';
import AuthWrapper from './AuthWrapper';
import { useUrlSearchParams } from 'use-url-search-params';
import { useSidebarActionsContext } from '../../utility/AppContextProvider/SidebarContextProvider';
import Layouts from './Layouts';
import 'ckeditor5/ckeditor5.css';
import 'ckeditor5-premium-features/ckeditor5-premium-features.css';
import { toast } from 'react-toastify';
import { useADActions } from '@tenant/services/auth/firebase/FirebaseAuthProvider';
import Error401 from 'pages/errorPages/Error401';
import { useDispatch, useSelector } from 'react-redux';
import { getUserPermissions } from 'redux/slices/authorization';
import AppLoader from '../AppLoader';

const AppLayout = () => {
  const { navStyle } = useLayoutContext();
  const { isAuthenticated, isAzurePermission } = useAuthUser();
  const { updateNavStyle } = useLayoutActionsContext();
  const { updateMenuStyle, setSidebarBgImage } = useSidebarActionsContext();
  const AppLayoutComponent = Layouts[navStyle];
  const [params] = useUrlSearchParams();
  const { logout } = useADActions();
  const dispatch = useDispatch();
  const { loadingPermission, loadedPermission, permissions } = useSelector(
    (state) => state.authorization,
  );

  useEffect(() => {
    if (params.layout) updateNavStyle(params.layout);
    if (params.menuStyle) updateMenuStyle(params.menuStyle);
    if (params.sidebarImage) setSidebarBgImage(true);
  }, [
    params.layout,
    params.menuStyle,
    params.sidebarImage,
    updateNavStyle,
    updateMenuStyle,
    setSidebarBgImage,
  ]);

  useEffect(() => {
    if (isAuthenticated && !isAzurePermission) {
      toast.error(
        'You do not have the necessary permissions to access this content. Please contact the administrator to request access.',
      );
      setTimeout(() => {
        logout();
      }, 5000);
    }

    if (isAuthenticated && !loadedPermission) {
      dispatch(getUserPermissions());
    }
  }, [isAuthenticated, isAzurePermission]);

  if (loadedPermission && permissions.length === 0 && isAuthenticated) {
    return <Error401 hideBtn showSwitchToAccount />;
  }

  return (
    <>
      {isAuthenticated ? (
        isAzurePermission ? (
          loadingPermission ? (
            <AppLoader />
          ) : (
            <AppLayoutComponent />
          )
        ) : (
          <Error401 hideBtn showSwitchToAccount />
        )
      ) : (
        <AuthWrapper>
          <AppContentView />
        </AuthWrapper>
      )}
    </>
  );
};

export default React.memo(AppLayout);
